import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Button from '../Button/Button';

const cssBlock = 'v2-button-group';

/**
 * Gruppo di bottoni.
 */
const ButtonGroup = ({ className, children }) => {
  const emphasisOfComps = useMemo(() => {
    // prendo l'enfasi del primo componente, visto che tutti devono avere la stessa enfasi.
    const comps = React.Children.toArray(children);
    let result = Button.Emphasis.LOW;
    if (comps.length > 0 && comps[0].props.emphasis) result = comps[0].props.emphasis;
    return result;
  }, [children]);

  const classes = cns(
    cssBlock,
    `${cssBlock}--${emphasisOfComps.toLowerCase()}`,
    className,
  );

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

ButtonGroup.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,

  /** Children del componente di tipo Button */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

ButtonGroup.defaultProps = {
  className: undefined,
};

export default ButtonGroup;
